import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut, Inbox, CalendarDays, Map, Tag, Rss, ScrollText, Wand2, ExternalLink, Wrench, MailPlus } from "lucide-react";
import { setToken } from "@/lib/api";

const linkBase = "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-display font-medium";
const linkIdle = "text-slate-300 hover:text-white hover:bg-white/5";
const linkActive = "bg-white/10 text-white";

export default function AdminLayout() {
  const nav = useNavigate();
  const logout = () => { setToken(null); nav("/admin/login"); };

  return (
    <div className="min-h-screen flex bg-[#F5F6F5]">
      <aside className="w-56 shrink-0 bg-[#0F2033] text-white flex flex-col">
        <div className="px-4 py-5 border-b border-white/10 font-display font-bold tracking-tight">
          <div className="text-[11px] uppercase tracking-widest text-slate-400">Southern Maine</div>
          <div className="text-lg leading-tight">Admin</div>
        </div>
        <nav className="p-2 flex-1 space-y-0.5" data-testid="admin-nav">
          <NavLink to="review" data-testid="nav-review" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Inbox size={16} strokeWidth={2} /> Review queue
          </NavLink>
          <NavLink to="submissions" data-testid="nav-submissions" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <MailPlus size={16} strokeWidth={2} /> Submissions
          </NavLink>
          <NavLink to="events" data-testid="nav-events" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <CalendarDays size={16} strokeWidth={2} /> All events
          </NavLink>
          <NavLink to="extract" data-testid="nav-extract" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Wand2 size={16} strokeWidth={2} /> AI extract
          </NavLink>
          <NavLink to="sources" data-testid="nav-sources" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Rss size={16} strokeWidth={2} /> Sources
          </NavLink>
          <NavLink to="towns" data-testid="nav-towns" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Map size={16} strokeWidth={2} /> Towns
          </NavLink>
          <NavLink to="categories" data-testid="nav-categories" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Tag size={16} strokeWidth={2} /> Categories
          </NavLink>
          <NavLink to="sync-logs" data-testid="nav-sync-logs" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <ScrollText size={16} strokeWidth={2} /> Sync logs
          </NavLink>
          <NavLink to="maintenance" data-testid="nav-maintenance" className={({isActive}) => `${linkBase} ${isActive ? linkActive : linkIdle}`}>
            <Wrench size={16} strokeWidth={2} /> Maintenance
          </NavLink>
        </nav>
        <div className="p-2 border-t border-white/10 space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className={`${linkBase} ${linkIdle}`} data-testid="view-site-link">
            <ExternalLink size={16} strokeWidth={2} /> View public site
          </a>
          <button onClick={logout} className={`${linkBase} ${linkIdle} w-full`} data-testid="logout-btn">
            <LogOut size={16} strokeWidth={2} /> Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto p-6">
        <Outlet />
      </main>
    </div>
  );
}
